import { ParticipantQrStatus } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';

interface Props extends ChakraV3.TagProps {
  status: ParticipantQrStatus;
}

export const participantQRStatusOptions = {
  [ParticipantQrStatus.Active]: {
    label: 'Active',
    value: ParticipantQrStatus.Active,
    raw: ParticipantQrStatus.Active,
    color: 'green',
  },
  [ParticipantQrStatus.Archived]: {
    label: 'Archived',
    value: ParticipantQrStatus.Archived,
    raw: ParticipantQrStatus.Archived,
    color: 'gray',
  },
};

export const ParticipantQRStatusTag = (props: Props) => {
  const { status, ...rest } = props;

  const { label, color } = participantQRStatusOptions[status];

  return (
    <ChakraV3.Tag colorPalette={color} w='fit-content' {...rest}>
      {label}
    </ChakraV3.Tag>
  );
};
